module.exports = __webpack_public_path__ + "img/logo_tengxunyun@2x.0d084bc9.png";